export default __webpack_public_path__ + "static/media/ic_history_b.1fe46a5d.svg";